import { useSDUIFilterablePaginatedSectionFilters } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/useSDUIFilterablePaginatedSectionFilters";
import { IGetSDUIFiltersRequest } from "@faire/web-api--source/indigofair/data/IGetSDUIFiltersRequest";
export var useSDUIFiltersRequest = function(filterablePaginatedSection) {
    var filterKeys = useSDUIFilterablePaginatedSectionFilters();
    var filteredComponentsRequest = filterablePaginatedSection.get_s_d_u_i_filtered_components;
    return IGetSDUIFiltersRequest.build({
        page_identifier: filteredComponentsRequest === null || filteredComponentsRequest === void 0 ? void 0 : filteredComponentsRequest.page_identifier,
        filter_keys: filterKeys
    });
};
